module.exports = __webpack_public_path__ + "img/banner6.bc3ff4b9.png";